import React from 'react';
import styled from 'libs/styled';
import Text from 'components/Text';
import Button from 'components/Button';
import { above } from '@fogia/core-web/utils/mediaqueries';
import type { FooterSocialMediaLink } from './types';

const Wrapper = styled('div')`
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-top: 1px solid var(--stroke-default);

    ${above['tablet.lg']} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0;
        border-top: none;
    }
`;

const SocialLinks = styled('div')`
    display: flex;
    align-items: center;
    gap: 0;
`;

const ContactInfo = styled('div')`
    display: flex;
    gap: 16px;
`;

const TEXT_TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, null, 'Primary/15_120_510_-1'];

interface BottomBarProps {
    socialMediaLinks?: FooterSocialMediaLink[];
    phone?: string;
    email?: string;
}

const hasLabelAndUrl = (link: FooterSocialMediaLink): link is FooterSocialMediaLink & { label: string; url: string } =>
    Boolean(link.label && link.url);

export const BottomBar = ({ socialMediaLinks, phone, email }: BottomBarProps) => {
    const validSocialLinks = socialMediaLinks?.filter(hasLabelAndUrl) ?? [];
    const hasSocialLinks = validSocialLinks.length > 0;
    const hasContact = phone || email;

    if (!hasSocialLinks && !hasContact) return null;

    return (
        <Wrapper>
            {hasSocialLinks && (
                <SocialLinks>
                    {validSocialLinks.map((link, index) => (
                        <React.Fragment key={link.label}>
                            {index > 0 && (
                                <Text typography={TEXT_TYPOGRAPHY} color="var(--ui-primary-aa)" px="4px">
                                    /
                                </Text>
                            )}
                            <Button
                                to={link.url}
                                target="_blank"
                                theme="textButton"
                                typography={TEXT_TYPOGRAPHY}
                                rel="noreferrer"
                            >
                                {link.label}
                            </Button>
                        </React.Fragment>
                    ))}
                </SocialLinks>
            )}
            {hasContact && (
                <ContactInfo>
                    {phone && (
                        <Button to={`tel:${phone}`} theme="textButton" typography={TEXT_TYPOGRAPHY}>
                            {phone}
                        </Button>
                    )}
                    {email && (
                        <Button to={`mailto:${email}`} theme="textButton" typography={TEXT_TYPOGRAPHY}>
                            {email}
                        </Button>
                    )}
                </ContactInfo>
            )}
        </Wrapper>
    );
};
